module.exports = new __parcel__URL__("leaderboard_pvp_button.db2a23ff.png").toString();